import { useEffect, useState } from 'react';
import ProductWrapper from '../../components/Product/ProductWrapper';
import Masonry from 'react-masonry-css';
import { ClipLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import './CatalogoPrivadoIframe.css';

function CatalogoPrivadoIframe() {
    const [productos, setProductos] = useState([]);
    const [provider, setProvider] = useState({});
    const [loading, setLoading] = useState(true);
    const [hasItems, setHasItems] = useState(false);

    // Configuración de breakpoints para Masonry
    const breakpointColumnsObj = {
        default: 6,
        1600: 6,
        1200: 5,
        768: 3,
        480: 2
    };

    useEffect(() => {
        const checkCart = () => {
            try {
                const cart = JSON.parse(localStorage.getItem('carritoPrivado')) || [];
                setHasItems(cart.length > 0);
            } catch {
                setHasItems(false);
            }
        };

        checkCart();

        // Escuchar cambios manuales al carrito (evento personalizado)
        window.addEventListener('cartPrivadoChanged', checkCart);

        return () => {
            window.removeEventListener('cartPrivadoChanged', checkCart);
        };
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const providerIdParam = params.get('providerId');

        if (!providerIdParam) return;

        // Guardar providerId en localStorage
        localStorage.setItem('providerId', providerIdParam);

        const fetchCatalog = async () => {
            try {
                const relatedRes = await fetch(`https://api.minymol.com/products/by-provider/${providerIdParam}`);
                const resIds = await relatedRes.json(); // esto es un array de IDs

                const ids = resIds.map(p => p.product_id).filter(Boolean);

                if (!Array.isArray(ids) || ids.length === 0) {
                    setProductos([]);
                    return;
                }

                const previewsRes = await fetch('https://api.minymol.com/products/previews', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ ids }),
                });

                const previews = await previewsRes.json();

                const activos = previews.filter(prod => !prod.isInactive);

                setProductos(activos);

                const providerRes = await fetch(`https://api.minymol.com/providers/public/${providerIdParam}`);
                const providerData = await providerRes.json();
                setProvider(providerData);
            } catch (err) {
                console.error('Error al cargar el catálogo del proveedor:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchCatalog();
    }, []);

    return (
        <div className="catalogo-privado-iframe">
            <div className='logo-provider'>
                <img src={provider.banner_url || '/logoSup.webp'} alt="Logo del proveedor" />
            </div>

            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh', width: '100%' }}>
                    <ClipLoader color="#fa7e17" size={30} />
                </div>
            ) : (
                <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="products-cont masonry-grid"
                    columnClassName="masonry-grid_column"
                >
                    {productos.map((prod, index) => (
                        <ProductWrapper key={`wrapper-${index}`} product={{...prod, privado: true}} index={index} />
                    ))}
                </Masonry>
            )}

            <a
                href="/carrito-privado"
                className={`floating-cart-btn ${hasItems ? 'pulse' : ''}`}
            >
                <FontAwesomeIcon icon={faShoppingCart} />
            </a>
        </div>
    );
}

export default CatalogoPrivadoIframe;
